import React from 'react';
import { motion } from 'framer-motion';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const faqItems: FAQItem[] = [
    {
      id: 1,
      question: "How long does a typical project take?",
      answer: "Project timelines vary based on complexity and scope. Simple automations can be completed in 1-2 weeks, while more complex systems might take 4-6 weeks. During our initial consultation, we'll provide a specific timeline based on your requirements."
    },
    {
      id: 2,
      question: "Can you help with existing AI and automation setups?",
      answer: "Absolutely! We specialize in both building new systems from scratch and optimizing existing setups. Our team can audit your current processes, identify bottlenecks, and implement improvements to enhance efficiency and results."
    },
    {
      id: 3,
      question: "How do you ensure the security of my data?",
      answer: "Data security is our top priority. We implement industry-standard encryption, secure access controls, and follow best practices for data handling. We're also transparent about which tools and platforms we use, ensuring compliance with relevant regulations and your specific security requirements."
    },
    {
      id: 4,
      question: "What will be needed from us?",
      answer: "For successful implementation, we'll need access to relevant systems, clear information about your current processes, and regular feedback during development. We'll guide you through each step and minimize the time commitment required from your team while ensuring the solution meets your specific needs."
    }
  ];

  return (
    <div className="bg-black py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-bold text-center mb-16"
        >
          Frequently Asked Questions
        </motion.h2>
        
        <div className="space-y-6">
          {faqItems.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="border border-primary/30 rounded-xl overflow-hidden"
            >
              <details className="group">
                <summary className="flex justify-between items-center p-6 cursor-pointer">
                  <h3 className="text-xl font-medium">{item.question}</h3>
                  <span className="text-accent">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 transform group-open:rotate-180 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <div className="px-6 pb-6 pt-0">
                  <p className="text-gray-300">{item.answer}</p>
                </div>
              </details>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
